<script setup lang="ts">
import { computed } from 'vue';
import { useToast } from 'primevue/usetoast';
import { PersonStores, useAuthStore } from '@/store';

const profileStore = PersonStores.useUserProfileStore();

const authStore = useAuthStore();

const toast = useToast();

const canImpersonate = computed<boolean>(() => {
  const person = profileStore.person;
  return !authStore.isImpersonating && !!person?.user?.can_login && !person?.archived_at;
});

const onImpersonate = async () => {
  await authStore.impersonate(profileStore.id as number);
  if (authStore.error) doFail(authStore.error);
};

const doFail = (detail: string) => {
  toast.add({
    severity: 'error',
    summary: 'Error',
    detail: detail,
    life: 3000,
  });
};
</script>

<template>
  <div v-if="canImpersonate">
    <AppButton type="secondary" text="Impersonate" icon-left="fingerprint" @click="onImpersonate" />
  </div>
</template>
